import { useEffect } from 'react'

declare global {
  interface Window {
    fbq: (...args: any[]) => void
    _fbq: (...args: any[]) => void
  }
}

export function useMetaPixel() {
  useEffect(() => {
    if (window.fbq) return

    const n: any = (window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!window._fbq) window._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = [] as any[]

    const t = document.createElement('script')
    t.async = true
    t.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(t)

    window.fbq('init', '925884956904085')
    window.fbq('track', 'PageView')
  }, [])
}

export function trackEvent(eventName: string, params?: Record<string, any>) {
  if (window.fbq) {
    window.fbq('track', eventName, params)
  }
}
